import React from 'react';
import { useReveal, useTilt } from '../shell';
import { certs } from '../data';

/** One credential. Own tilt ref per card, same as the app and project grids. */
const CertCard = ({ cert }) => {
  const tilt = useTilt();

  return (
    <article ref={tilt} className="m-card m-reveal">
      <div className="m-card__media">
        <img
          src={cert.image}
          alt={cert.title}
          loading="lazy"
          decoding="async"
          width="640"
          height="400"
        />
      </div>

      <div className="m-card__body">
        <div className="m-card__kicker">
          {cert.issuer} · {cert.year} · {cert.hours}
        </div>
        <h3 className="m-card__title">{cert.title}</h3>
        <p className="m-card__short">{cert.description}</p>

        <div className="m-tags">
          {cert.tech.map((t) => (
            <span key={t} className="m-tag">
              {t}
            </span>
          ))}
        </div>
      </div>

      <div className="m-card__links">
        <a
          className="m-btn m-btn--primary"
          href={cert.verify}
          target="_blank"
          rel="noopener noreferrer"
        >
          Verify
        </a>
        <a
          className="m-btn m-btn--secondary"
          href={cert.download}
          target="_blank"
          rel="noopener noreferrer"
        >
          Certificate
        </a>
      </div>
    </article>
  );
};

const Certifications = () => {
  useReveal([]);

  return (
    <>
      <section className="m-head">
        <div className="m-head__kicker">Certifications</div>
        <h1 className="m-head__title">
          Signed
          <br />
          off
        </h1>
        <p className="m-head__lead">
          Every credential links back to the issuer&rsquo;s own verification record. Nothing here
          is self-attested.
        </p>
      </section>

      <section className="m-section--grid">
        <div className="m-cards">
          {certs.map((c) => (
            <CertCard key={c.id} cert={c} />
          ))}
        </div>
      </section>
    </>
  );
};

export default Certifications;
